import React from 'react'
import { Slide, Theme, ToastContainer, ToastTransition } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

interface NotificationContainerProps {
  rtl?: boolean
  transition?: ToastTransition
  theme?: Theme
}

function NotificationContainer({
  rtl = false,
  transition = Slide,
  theme = 'colored',
}: NotificationContainerProps) {
  return <ToastContainer rtl={rtl} transition={transition} theme={theme} />
}

export default NotificationContainer
